export default __webpack_public_path__ + "static/media/mobile-device.4b264d12.svg";